import {ROLES} from 'consts/roles'
import {computed} from 'vue'


export default {
  __name: 'role',
  props: {
  type: {
    type: String,
    required: true,
    // Example: 'economic_buyer'
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const role_data = computed(() => {
  return ROLES.find(r => r.type === props.type)
})

const __returned__ = { props, role_data, get ROLES() { return ROLES }, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}